import { TBusinessAreaResponse } from '~/app-modules/business-area/clients/dto/business-area-response';
import { PermissionType } from '~/app-modules/user-access-right/clients/enums/permission-type';

interface CurrentUserModel {
  firstName: string;
  lastName: string;
  permissions: PermissionType[];
}

@singleton()
export class UserStore {
  private _currentUser = ref<CurrentUserModel>();
  private _allAvailableBusinessAreas: Ref<TBusinessAreaResponse[]> = ref([]);

  private _currentBusinessArea: Ref<TBusinessAreaResponse | null> = useCookie(
    'backoffice-current-business-area',
    {
      default: () => null,
    },
  );

  get currentUser(): CurrentUserModel | undefined {
    return this._currentUser.value;
  }

  set currentUser(value: CurrentUserModel | undefined) {
    this._currentUser.value = value;
  }

  get fullName(): string {
    if (!this._currentUser.value) return '';

    const { lastName, firstName } = this._currentUser.value;
    return `${lastName} ${firstName}`;
  }

  // async tryLoadUser() {
  //   if (!this.authService.isLoggedIn) return;
  //
  //   const [currentUser, permissions] = await Promise.all([
  //     this.authUserService.getCurrentUser(),
  //     this.userAccessRightService.getPermissionsForCurrentUser(),
  //   ]);
  //
  //   this._currentUser.value = {
  //     firstName: currentUser.firstName,
  //     lastName: currentUser.lastName,
  //     permissions,
  //   };
  // }
  //
  // async reloadBusinessAreas() {
  //   this._allAvailableBusinessAreas.value =
  //     await this.businessAreaService.getAvailableForCurrentUser();
  //
  //   const needSetDefaultBusinessArea =
  //     !this._currentBusinessArea.value ||
  //     !this._allAvailableBusinessAreas.value.some(
  //       (ba) => ba.id === this._currentBusinessArea.value!.id
  //     );
  //
  //   if (needSetDefaultBusinessArea) {
  //     this._currentBusinessArea.value = this._allAvailableBusinessAreas.value[0];
  //   }
  // }

  get allAvailableBusinessAreas(): TBusinessAreaResponse[] {
    return this._allAvailableBusinessAreas.value;
  }

  set allAvailableBusinessAreas(value: TBusinessAreaResponse[]) {
    this._allAvailableBusinessAreas.value = value;
  }

  get currentBusinessArea(): TBusinessAreaResponse {
    return this._currentBusinessArea.value!;
  }

  set currentBusinessArea(value: TBusinessAreaResponse) {
    this._currentBusinessArea.value = value;
  }
}
